import { SeatRow } from '../models/serializable/seating/seat-row.js';
import { Seat } from '../models/serializable/seating/seat.js';
import { SeatingElement } from '../models/serializable/seating/seating-element.js';
import { SeatingLayout } from '../models/serializable/seating/seating-layout.js';
import { Sector } from '../models/serializable/seating/sector.js';
import { StandingArea } from '../models/serializable/seating/standing-area.js';

export function* findAllSeatsOfSeatingLayout(
    seatingLayout: SeatingLayout,
): Generator<Seat> {
  for(const child of seatingLayout.children) {
    yield* findAllSeatsOfSeatingElement(child);
  }
}

export function* findAllSeatsOfSeatingElement(
    seatingElement: SeatingElement,
): Generator<Seat> {
  switch(true) {
    case seatingElement instanceof Seat: {
      yield seatingElement;
      return;
    } break;
    case seatingElement instanceof SeatRow: {
      for(const seat of seatingElement.seats) {
        yield seat;
      }
    } break;
    case seatingElement instanceof Sector: {
      for(const child of seatingElement.children) {
        yield* findAllSeatsOfSeatingElement(child);
      }
    } break;
  }
}

export function* findStandingAreas(elements: readonly SeatingElement[]): Generator<StandingArea> {
  for(const element of elements) {
    if(element instanceof StandingArea) {
      yield element;
    }
    else if(element instanceof Sector) {
      yield* findStandingAreas(element.children);
    }
  }
}

export function countAllSeatsOfSeatingLayout(
    seatingLayout: SeatingLayout,
): number {
  const seats = findAllSeatsOfSeatingLayout(seatingLayout);
  let size = 0;
  for(const _ of seats) {
    size++;
  }

  return size;
}
